<template>
  <div class="bottom-navigation" :class="{'hidden' : isHidden}">
    <v-bottom-nav id="qa-bottom-navigation" :class="{'ios-height' :  userAgent === 'ios' && iosAppVersion === 'fromWeb'}" app fixed :value="true" height="60">
      <div @click="toggleBetslip()" class="betslip_mobile_msg" v-show="brandTemplate === 'generic_2' && selectionsNo && betslipMobileIsVisible && navgroupcontext4menu !== 'pm'" >
        <span class="feedback-label" >
          <span class="badge">{{selectionsNo}}</span>
          <span class="betslip-label">{{ selectionsNo > 1 ? $t('BottomNav.Betslip.Selections') :  $t('BottomNav.Betslip.Selection')}}</span>
        </span>
        <span class="betslip_up_icon"></span>
        <span class="feedback-msg" >
          <div>{{feedback}}</div>
<!--          <div v-if="feedbackSGPplusParticipants">{{feedbackSGPplusParticipants}}</div>-->
        </span>
      </div>
      <!--PM Betslip-->
      <div @click="togglePmBetslip()" class="betslip_mobile_msg" v-show="!isReadOnly && brandTemplate === 'generic_2' && pmSelectedRunnersCount && betslipMobileIsVisible && navgroupcontext4menu === 'pm'" >
        <span class="feedback-label" >
          <span class="badge">{{pmSelectedRunnersCount}}</span>
          <span class="betslip-label">{{ pmSelectedRunnersCount > 1 ? $t('Betslip.PM.Runners') :  $t('Betslip.PM.Runner')}}</span>
        </span>
        <span class="betslip_up_icon"></span>
      </div>
      <template v-if="routerNavGroups && routerNavGroups.navset === 'mixed' && hasActiveNavGroups(['pm']) && navgroupcontext4menu === 'pm'">
        <v-btn id="qa-sports-home" :ripple="false" @click="()=>{ togglePmBetslipOff(); go2PmBetting(); }" flat color="teal" value="recent" class="sports menu" :class="[{'home promotions-v2': brandLayout==='generic'}, {'active': activeHomePM}]">
          <div class="btn-icon-container"><icon name="icon-home"></icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.RacingHome') }}</span>
        </v-btn>
        <v-btn id="qa-sports-horseracing" :ripple="false" @click="()=>{ togglePmBetslipOff(); toggleMenu(); }" flat color="teal" value="recent" class="sports menu" :class="[{'active': dialogSportsMenu || isSportsActive}, {'btnHR': brandLayout==='generic'}]">
          <div class="btn-icon-container"><span class="icon-horseracing"></span></div>
          <span class="bottom_nav_text" :class="dialogSportsMenu ? 'blue' : ''">{{ $t('BottomNav.AllRacing') }}</span>
        </v-btn>
        <router-link :to="{name: 'sports'}" class="v-btn">
          <v-btn id="qa-sports-nfl" :ripple="false" @click="()=>{ togglePmBetslipOff(); toggleHome(); }" flat value="favorites" class="home promotions-v2" :class="[{'active': activeHome}, {'sports home': brandLayout==='generic'}]">
            <div class="btn-icon-container"><icon name="icon-nfl" :colorName="'blue'"></icon></div>
            <span class="bottom_nav_text">{{ $t('BottomNav.Sports') }}</span>
          </v-btn>
        </router-link>
        <v-btn v-if="canHaveNavElm('BETSLIP')" id="qa-sports-betslip-icon" :ripple="false" @click="togglePmBetslip()" flat color="teal" value="recent" class="sports menu" :class="[{'active': pmShowBetSlip}, {'betslip-button': brandLayout==='generic'}]">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Betslip') }}</span>
          <badge :class="{'ios-badge' :  userAgent !== 'ios' && iosAppVersion === 'fromWeb'}" v-if="pmSelectedRunnersCount > 0">{{pmSelectedRunnersCount}}</badge>
        </v-btn>
        <v-btn id="qa-sports-betslip-icon" v-if="canHaveNavElm('MYBETS') && brandTemplate ==='generic_2'" :ripple="false" @click="toggleMyBets()" flat value="nearby" class="betslip-button" :class="{'active': isMyBetsActive}">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.MyBets') }}</span>
        </v-btn>
      </template>

      <template v-else-if="routerNavGroups && routerNavGroups.navset === 'mixed' && hasActiveNavGroups(['pm']) && navgroupcontext4menu !== 'pm'">
        <router-link :to="{name: 'sports'}" class="v-btn">
          <v-btn id="qa-sports-home" :ripple="false" @click="toggleHome()" flat value="favorites" class="home promotions-v2" :class="{'active': activeHome}">
            <div class="btn-icon-container"><icon name="icon-home" :colorName="activeHome ? 'blue' : 'dark'"></icon></div>
            <span class="bottom_nav_text" :class="activeHome ? 'blue' : ''">{{ $t('BottomNav.SportsHome') }}</span>
          </v-btn>
        </router-link>
        <v-btn id="qa-sports-nfl" :ripple="false" @click="toggleMenu()" flat color="teal" value="recent" class="sports menu" :class="{'active': dialogSportsMenu  || isSportsActive}">
          <div class="btn-icon-container"><icon name="icon-nfl" :colorName="'blue'"></icon></div>
          <span class="bottom_nav_text" :class="dialogSportsMenu ? 'blue' : ''">{{ $t('BottomNav.AllSports') }}</span>
        </v-btn>
        <v-btn id="qa-sports-horseracing" :ripple="false" @click="go2PmBetting()" flat color="teal" value="recent" class="sports menu" :class="{'btnHR': brandLayout==='generic'}">
          <div class="btn-icon-container"><span class="icon-horseracing"></span></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Racing') }}</span>
        </v-btn>
        <v-btn v-if="canHaveNavElm('BETSLIP')" id="qa-sports-betslip-icon" :ripple="false" @click="toggleBetslip()" flat value="nearby" class="betslip-button" :class="{'active': dialogBetslip, 'hasSelections' : selectionsNo > 0}">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Betslip') }}</span>
          <badge :class="{'ios-badge' :  userAgent !== 'ios' && iosAppVersion === 'fromWeb'}" v-if="selectionsNo > 0">{{selectionsNo}}</badge>
          <div :class="{'ios_betslip_mobile_msg' :  userAgent === 'ios' && iosAppVersion === 'fromWeb'}" class="betslip_mobile_msg" v-show="feedback"><p>{{feedback}}</p></div>
        </v-btn>
        <v-btn id="qa-sports-betslip-icon" v-if="canHaveNavElm('MYBETS') && brandTemplate ==='generic_2'" :ripple="false" @click="toggleMyBets()" flat value="nearby" class="betslip-button" :class="{'active': isMyBetsActive}">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.MyBets') }}</span>
        </v-btn>
      </template>

      <template v-else-if="routerNavGroups && routerNavGroups.navset === 'pm'">
        <v-btn id="qa-sports-home" :ripple="false" @click="()=>{ togglePmBetslipOff(); go2PmBetting(); }" flat color="teal" value="recent" class="sports menu" :class="{'home promotions-v2': brandLayout==='generic'}">
          <div class="btn-icon-container"><icon name="icon-home"></icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Home') }}</span>
        </v-btn>
        <v-btn id="qa-sports-horseracing" :ripple="false" @click="()=>{ togglePmBetslipOff(); toggleMenu(); }" flat color="teal" value="recent" class="sports menu" :class="[{'active': dialogSportsMenu || isSportsActive}, {'btnHR': brandLayout==='generic'}]">
          <div class="btn-icon-container"><span class="icon-horseracing"></span></div>
          <span class="bottom_nav_text" :class="dialogSportsMenu ? 'blue' : ''">{{ $t('BottomNav.AllRacing') }}</span>
        </v-btn>
        <v-btn id="qa-sports-betslip-icon" :ripple="false" @click="togglePmBetslip()" flat color="teal" value="recent" class="sports menu" :class="[{'active': pmShowBetSlip}, {'betslip-button': brandLayout==='generic'}]">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Betslip') }}</span>
          <badge :class="{'ios-badge' :  userAgent !== 'ios' && iosAppVersion === 'fromWeb'}" v-if="pmSelectedRunnersCount > 0">{{pmSelectedRunnersCount}}</badge>
        </v-btn>
      </template>

      <template v-else-if="routerNavGroups && routerNavGroups.navset === 'mixed' && navgroupcontext4menu === 'racing'">
        <router-link :to="{name: 'sports'}" class="v-btn">
          <v-btn id="qa-sports-home" :ripple="false" @click="toggleHome()" flat value="favorites" class="home promotions-v2">
            <div class="btn-icon-container"><icon name="icon-home" :colorName="activeHome ? 'blue' : 'dark'"></icon></div>
            <span class="bottom_nav_text">{{ $t('BottomNav.SportsHome') }}</span>
          </v-btn>
        </router-link>
        <v-btn id="qa-racing-menu" :ripple="false" @click="()=>{ emitNavigationEvent('notifyRacingIframeToDo', {action:'toggle-menu'}); }" flat color="teal" class="btnracing">
          <div class="btn-icon-container"><v-icon class="icon-racing icon-racingmenu"></v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.RacingMenu') }}</span>
        </v-btn>
        <v-btn id="qa-racing-home" :ripple="false" @click="()=>{ emitNavigationEvent('notifyRacingIframeToDo', {action:'go-home'}); }" flat color="teal" class="btnracing">
          <div class="btn-icon-container"><span class="icon-racing icon-racinghome"></span></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.RacingHome') }}</span>
        </v-btn>
      </template>

      <template v-else>
        <router-link v-if="canHaveNavElm('HOME')" :to="{name: 'sports'}" class="v-btn">
          <v-btn id="qa-sports-home" :ripple="false" @click="toggleHome()" flat value="favorites" class="home promotions-v2" :class="{'active': activeHome}">
            <div class="btn-icon-container"><icon name="icon-home" :colorName="activeHome ? 'blue' : 'dark'"></icon></div>
            <span class="bottom_nav_text" :class="activeHome ? 'blue' : ''">{{ $t('BottomNav.Home') }}</span>
          </v-btn>
        </router-link>
        <v-btn id="qa-sports-nfl" v-if="canHaveNavElm('SPORTS')" :ripple="false" @click="toggleMenu()" flat color="teal" value="recent" class="sports menu" :class="{'active': dialogSportsMenu || isSportsActive}">
          <div class="btn-icon-container"><icon name="icon-nfl" :colorName="'blue'"></icon></div>
          <span class="bottom_nav_text" :class="dialogSportsMenu ? 'blue' : ''">{{ $t('BottomNav.AllSports') }}</span>
        </v-btn>
        <v-btn id="qa-sports-betslip-icon" v-if="canHaveNavElm('BETSLIP')" :ripple="false" @click="toggleBetslip()" flat value="nearby" class="betslip-button" :class="{'active': dialogBetslip, 'hasSelections' : selectionsNo > 0}">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.Betslip') }}</span>
          <badge :class="{'ios-badge' :  userAgent !== 'ios' && iosAppVersion === 'fromWeb'}" v-if="selectionsNo > 0">{{selectionsNo}}</badge>
          <div :class="{'ios_betslip_mobile_msg' :  userAgent === 'ios' && iosAppVersion === 'fromWeb'}" class="betslip_mobile_msg" v-show="feedback"><p>{{feedback}}</p></div>
        </v-btn>
        <v-btn id="qa-sports-betslip-icon" v-if="canHaveNavElm('MYBETS') && brandTemplate ==='generic_2'" :ripple="false" @click="toggleMyBets()" flat value="nearby" class="betslip-button" :class="{'active': isMyBetsActive}">
          <div class="btn-icon-container"><v-icon class="betslip-icon">receipt</v-icon></div>
          <span class="bottom_nav_text">{{ $t('BottomNav.MyBets') }}</span>
        </v-btn>
      </template>

      <v-btn id="qa-sports-specialLink" @click="specialLink()" v-if="navigationType">
        <div class="btn-icon-container"><icon :name="navigationName" :colorName="'dark'"></icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.SpecialLink') }}</span>
      </v-btn>
      <v-btn id="qa-sports-promos" v-if="canHaveNavElm('PROMOS')" class="promo" @click="go2Promotions()" :class="{'active': isPromotionsPageActive}">
        <div class="btn-icon-container"><v-icon>stars</v-icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.Promos') }}</span>
      </v-btn>
      <v-btn id="qa-sports-placed-bets" v-if="canHaveNavElm('PLACED_BETS')" class="placed_bets" @click="go2PlacedBets()" :class="{'active': isPlacedBetsPageActive}">
        <div class="btn-icon-container"><v-icon>attach_money</v-icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.PlacedBets') }}</span>
      </v-btn>
      <v-btn id="qa-sports-saved-bets" v-if="canHaveNavElm('SAVED_BETS')" class="saved_bets" @click="go2SavedBets()" :class="{'active': isSavedBetsPageActive}">
        <div class="btn-icon-container"><v-icon>save</v-icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.SavedBets') }}</span>
      </v-btn>
      <v-btn v-if="canHaveNavElm('INFO')" @click="toggleHamburgerMenu()" flat class="info" :class="{'active': dialogHamburgerMenu || isInfoActive}">
        <div class="btn-icon-container"><icon name="icon-info"></icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.Info') }}</span>
      </v-btn>
      <v-btn v-if="canHaveNavElm('CONTESTS')" class="contests" @click="go2Contests()" :class="{'active': isContestsPageActive}">
        <div class="btn-icon-container"><v-icon>stars</v-icon></div>
        <span class="bottom_nav_text">{{ $t('BottomNav.Contests') }}</span>
      </v-btn>

      <v-btn id="qa-sports-profile" :ripple="false" v-if="canHaveNavElm('PROFILE')" @click="()=>{ if(isLoggedIn) { toggleMyAccount() } else { toggleLogin(); } }" flat value="nearby" class="account" :class="[{'active': dialogMyAccount || isMyProfileActive}, {'withAlerts' : noOfMsgs > 0 && isLoggedIn}]">
        <div v-if="brandTemplate !== 'generic_2'" class="btn-icon-container">
          <v-icon>account_circle</v-icon>
        </div>
        <div v-if="brandTemplate === 'generic_2'" class="btn-icon-container">
          <v-icon>account_circle</v-icon>
        </div>
        <span class="bottom_nav_text" :class="dialogMyAccount ? 'blue' : ''">{{ $t('BottomNav.Profile') }}</span>
      </v-btn>
    </v-bottom-nav>

    <v-navigation-drawer class="dialog-menu dialogsportsmenu" v-if="mobileBigAndBelow" v-model="dialogSportsMenu" app fixed disable-resize-watcher disable-route-watcher>
      <div v-if="brandLayout !== 'generic' && brandKey !=='sb'" class="header">
        <v-layout class="title">
          <v-flex class="logo-wrapper">
            <logo mode="light"></logo>
          </v-flex>
          <v-flex class="close">
            <v-btn flat @click="toggleMenu()" class="close"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-flex v-if="brandKey === 'sb' || (brandLayout === 'generic' && brandTemplate !== 'generic_2')" class="close">
        <v-btn flat @click="toggleMenu()" class="close"><v-icon>close</v-icon></v-btn>
      </v-flex>
      <div v-if="(routerNavGroups.navset === 'mixed' && navgroupcontext4menu === 'pm') || routerNavGroups.navset === 'pm'" class="sports-menu">
        <site-navigation :navigation-section="'RACING_MENU_TOP'" class="popular expand navigation topmenu"></site-navigation>
        <div class="wrapper sports-az all_racing navigation">
          <h3><span>All Racing</span></h3>
          <ul class="bo-navigation">
            <li v-for="(breed, breedIx) in pmMeetingsBreeds" :key="breedIx" class="navigation-item"><a @click="pmNavToBreed(breed)"><icon :name="'icon-' + breed.toLowerCase()"></icon>{{breed}}</a></li>
          </ul>
        </div>
      </div>
      <template v-else>
        <div v-if="brandTemplate === 'generic_2'" class="sports_menu_header_holder">
          <div class="sports_menu_header">
            <h3>{{ $t('Sports.SportAZ') }}</h3>
          </div>
          <!-- <div class="search-bar" v-if="isSearchEnabled">
            <div class="search-fields-container">
              <div class="search-icon"><icon name="icon-search"></icon></div>
              <input class="search-filed" placeholder="Search..." @click="goToSearchPage()" type="text"></input>
            </div>
          </div> -->
        </div>
        <sports-menu></sports-menu>
      </template>
    </v-navigation-drawer>
     <!-- Info menu -->
    <v-navigation-drawer class="dialog-menu hamburger" v-if="mobileBigAndBelow && brandLayout === 'generic' && isInfoMenuEnabled" v-model="dialogHamburgerMenu" app fixed disable-resize-watcher disable-route-watcher>
      <div v-if="brandTemplate === 'generic_2'" class="sports_menu_header_holder">
        <div class="sports_menu_header">
          <h3>{{ $t('BottomNav.Info') }}</h3>
        </div>
      </div>
      <div v-if="brandTemplate !== 'generic_2'" class="header">
        <v-btn flat @click="toggleHamburgerMenu()" class="close"><v-icon>close</v-icon></v-btn>
      </div>
      <hamburger-menu></hamburger-menu>
    </v-navigation-drawer>

    <v-dialog content-class="dialog-betslip" v-if="mobileBigAndBelow" v-model="dialogBetslip" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
      <betslip></betslip>
    </v-dialog>
    <v-dialog content-class="dialog-betslip pm" v-if="mobileBigAndBelow" v-model="dialogBetslipPM" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
      <betslip-pari-mutuel></betslip-pari-mutuel>
    </v-dialog>
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'
  import Screen from '@/components/mixins/Screen'
  import Session from '@/components/mixins/Session'
  import Badge from '@/components/common/Badge'
  import SportsMenu from '@/components/sports/bettingoffer/sportsMenu'
  import HeaderInfo from '@/components/common/HeaderInfo'
  import Logo from '@/components/common/Logo'
  import Betslip from '@/components/sports/betslipV2/betslipPage'
  import BetslipPariMutuel from '@/components/parimutuel/betting/BetslipMobile'
  import Icon from '@/components/common/Icon'
  import Gtm from '@/components/mixins/Gtm'
  import Branding from '@/components/mixins/Branding'
  import Url from '@/components/mixins/Url'
  import lib from '@/library'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import mobileBridge from '@/library/mobileBridge'
  import HamburgerMenu from '@/components/layout/parts/hamburgerMenu'
  import MessageCenter from '@/components/layout/parts/MessageCenter'
  import priceFormat from '@/library/priceFormat'

  export default {
    name: 'BottomNavigation',

    mixins: [
      Screen,
      Session,
      Url,
      Gtm,
      Branding
    ],

    components: {
      Badge,
      Logo,
      SportsMenu,
      Betslip,
      BetslipPariMutuel,
      HeaderInfo,
      Icon,
      SiteNavigation,
      HamburgerMenu,
      MessageCenter
    },

    props: {
      text: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      sessionTime: 0,
      feedback: '',
      feedbackSGPplusParticipants: '',
      feedbackTo: null,
      isClickedFromBottomNavigation: false,
      navgroupcontext4menu: '',
      doShowParlayMsg: false
    }),

    computed: {
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      sessionDetails () {
        return store.getters['getSessionDetails']
      },
      userAgent () {
        return lib.core.userAgent.os.name
      },
      iosAppVersion () {
        if (navigator.appVersion.indexOf('Safari') !== -1) {
          return 'fromWeb'
        } else {
          return undefined
        }
      },
      state () {
        return config.app.autoconf.STATE
      },
      dialogSportsMenu: {
        get: function () {
          return store.getters['overlayState/getSportsMenuState']
        },
        set: function (value) {
          if (value) {
            store.dispatch('overlayState/activateSportsMenu')
          } else {
            store.dispatch('overlayState/deactivateSportsMenu')
          }
        }
      },

      dialogMyAccount () {
        return store.getters['overlayState/getMyAccountDialogState']
      },
      dialogBetslip () {
        return store.getters['overlayState/getBetslipState']
      },
      dialogBetslipPM () {
        return store.getters['pmBetslipState/getShowBetSlip']
      },
      selectionsNo () {
        return store.getters['sbBetslipState/selectionsNo']
      },
      allowedReturnsPRL () {
        return store.getters['sbBetslipState/allowedReturnsPRL']
      },
      allowedReturnsSGP () {
        return store.getters['sbBetslipState/allowedReturnsSGP']
      },
      allowedReturnsSingles () {
        return store.getters['sbBetslipState/allowedReturnsSingles']
      },
      gettingABTnR () {
        return store.getters['sbBetslipState/gettingABTnR']
      },
      mobileFeedback () {
        return store.getters['sbBetslipState/mobileFeedback']
      },
      isFastBetEnabled () {
        return store.getters['sbBetslipState/isFastBetEnabled']
      },
      popBetSlipOn1stSelection () {
        return store.getters['sbBetslipState/popBetSlipOn1stSelection']
      },
      activeHome () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false && !this.dialogHamburgerMenu && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false && this.$route.name === 'sports') {
          return true
        }
      },
      activeHomePM () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false && !this.dialogHamburgerMenu && !this.dialogBetslipPM && store.getters['overlayState/getSportsMenuState'] === false && this.$route.name === 'pmbetting') {
          return true
        }
      },
      betSlipStatus () {
        return store.getters['sbBetslipState/betSlipStatus']
      },
      isAuthServerEnabled () {
        return config.app.autoconf.AUTH_SERVER_ENABLED
      },
      betslipMobileIsVisible () {
        if (!store.getters['overlayState/getSingleBetslipState'].active &&
        !store.getters['overlayState/getSportsMenuState'] &&
        !store.getters['overlayState/getHamburgerMenuState'] &&
        !store.getters['overlayState/getMyAccountDialogState'] && this.$route.path.indexOf('/account/') < 0) {
          return true
        }
      },
      isHidden () {
        // store.getters['overlayState/getBetslipState'] === true
        if ((this.betSlipStatus.State === 2 && store.getters['overlayState/getBetslipState'] === true) ||
          (this.$route.name === 'logout' === true && this.brandTemplate === 'generic_2') ||
          (store.getters['overlayState/getBetslipState'] === true && this.brandTemplate === 'generic_2') ||
          (store.getters['pmBetslipState/getShowBetSlip'] && this.brandTemplate === 'generic_2') ||
          (store.getters['overlayState/getSingleBetslipState'].active === true && this.brandTemplate !== 'generic_2') ||
          (store.getters['overlayState/getSportsMenuState'] === true && this.brandTemplate !== 'generic_2') ||
          (store.getters['overlayState/getHamburgerMenuState'] === true && this.brandTemplate !== 'generic_2') ||
          store.getters['overlayState/getCompetitionSelectDialogState'] === true ||
          store.getters['overlayState/getBetslipMsg'].active === true ||
          store.getters['overlayState/getBetslipConfirm'].active === true ||
          store.getters['overlayState/getSpecialOfferInfoState'].active === true ||
          store.getters['overlayState/getWishBetMsgDialogState'].active === true ||
          // (store.getters['overlayState/getBetslipMsg'].active === true && store.getters['overlayState/getBetslipState'] === true) ||
          // (store.getters['overlayState/getBetslipConfirm'].active === true && store.getters['overlayState/getBetslipState'] === true) ||
          (store.getters['overlayState/getMyAccountDialogState'] === true && store.getters['isLoggedIn'] === false) ||
          store.getters['overlayState/getLoginDialogState'] === true ||
          store.getters['overlayState/getJoinDialogState'] === true ||
          store.getters['overlayState/getLoginHeadlineDialogState'] === true ||
          store.getters['overlayState/getHeadlineOverlayDialogState'] === true ||
          (!this.isAuthServerEnabled && store.getters['getIs2FA'] === false && store.getters['get2FADisableTrust'] === false) ||
          store.getters['overlayState/getContestSliderMenuState'] === true ||
          store.getters['overlayState/getAuthDialogState'] !== false ||
          store.getters['overlayState/getPopularParlaysDialogState'].active !== false ||
          store.getters['overlayState/getContestsPopupOverlayState'] === true ||
          store.getters['overlayState/getPlayerPropsDialogState'] ||
          store.getters['overlayState/getAddingSelectionDialogState'] === true ||
          (store.getters['pmBetslipState/getPlaceBetStatus'] && store.getters['pmBetslipState/getPlaceBetStatus'] === 'P') ||
          store.getters['overlayState/getFastSwitchDialog'] === true) {
          return true
        }
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      navigationSections () {
        return store.getters['siteNavigationState/navigationSections']
      },
      defaultNavigationSection () {
        return 'BOTTOM_NAV_MOBILE_APP_SPECIAL'
      },
      stateNavigationSection () {
        return this.defaultNavigationSection + '_' + this.state
      },
      navigationSectionById () {
        return (this.navigationSections && (this.navigationSections[this.stateNavigationSection] || this.navigationSections[this.defaultNavigationSection])) || undefined
      },
      navigationType () {
        if (this.navigationSectionById && this.navigationSectionById.fwnavigationgroups[0] && this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0]) {
          return (this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0].display === 'ALWAYS') ||
            (this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0].display === 'LOGGEDIN' && this.isLoggedIn) ||
            (this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0].display === 'LOGGEDOUT' && !this.isLoggedIn)
        }
      },
      navigationName () {
        if (this.navigationSectionById && this.navigationSectionById.fwnavigationgroups[0] && this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0]) {
          return this.navigationSectionById.fwnavigationgroups[0].fwnavigationitems[0].cssclass
        }
      },
      walletProvider () {
        return config.app.autoconf.WALLET_PROVIDER
      },
      webView () {
        var sufix = ''
        if (this.isOpenedFromWebView && this.walletProvider === 'GAN') {
          sufix = '?uiView=true'
        }
        return sufix
      },
      externalUrls () {
        return config.externalUrls
      },
      dialogHamburgerMenu: {
        get: function () {
          return store.getters['overlayState/getHamburgerMenuState']
        },
        set: function (value) {
          if (value) {
            store.dispatch('overlayState/activateHamburgerMenu')
          } else {
            store.dispatch('overlayState/deactivateHamburgerMenu')
          }
        }
      },
      isPromotionsPageActive () {
        if (this.$route.path.indexOf('/account/') === -1 && store.getters['overlayState/getMyAccountDialogState'] === false && !this.dialogHamburgerMenu && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false && (this.$route.name === 'promotions' || this.$route.path.indexOf('/info/promotions') > -1)) {
          return true
        }
      },
      isSavedBetsPageActive () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false && !this.dialogHamburgerMenu && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false && !this.$route.name !== 'promotions' & this.$route.path !== '/info/promotions' && this.$route.path === '/savedbets') {
          return true
        }
      },
      isPlacedBetsPageActive () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false && !this.dialogHamburgerMenu && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false && !this.$route.name !== 'promotions' & this.$route.path !== '/info/promotions' && this.$route.path !== '/savedbets' && this.$route.path === '/placedbets') {
          return true
        }
      },
      pmShowBetSlip () { return store.getters['pmBetslipState/getShowBetSlip'] },
      pmSelectedRunnersCount () { return store.getters['pmBetslipState/getSelectedRunnersCount'] },
      routerNavGroups () {
        let rngs = config.app.autoconf.ROUTERNAVGROUPS
        return rngs
      },
      pmMeetingsBreeds () {
        let meetings = store.getters['racecardState/getMeetings'] || []
        let isOther = false
        let sts = new Set()
        for (let i = 0; i < meetings.length; i++) {
          if (meetings[i].breed === 'Others') {
            isOther = true
          } else {
            sts.add(meetings[i].breed)
          }
        }
        if (isOther) {
          sts.add('Others')
        }
        return sts
      },
      isContestsPageActive () {
        if (store.getters['overlayState/getMyAccountDialogState'] === false &&
            !this.dialogHamburgerMenu &&
            store.getters['overlayState/getBetslipState'] === false &&
            store.getters['overlayState/getSportsMenuState'] === false &&
            this.$route.name === 'contests') {
          return true
        }
      },
      biometricsAvailability () {
        return store.getters['getBiometricsAvailability']
      },
      biometricsSettings () {
        return store.getters['getBiometricsSettings']
      },
      MobilelocalServer () {
        return window.ctsautoconf.MOBILE_LS || false
      },
      currencySymbol () {
        return config.app.CURRENCY
      },
      isInfoActive () {
        if ((this.$route.name === 'pspromotions' || this.$route.path.indexOf('/info/') > -1) && store.getters['overlayState/getMyAccountDialogState'] === false && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false) {
          return true
        }
      },
      isMyProfileActive () {
        if ((this.$route.name !== 'history-state' && this.brandTemplate === 'generic_2') && this.$route.path.indexOf('/account/') > -1 && store.getters['overlayState/getHamburgerMenuState'] === false && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getSportsMenuState'] === false) {
          return true
        }
      },
      isSportsActive () {
        if ((this.$route.path.indexOf('/sports/event/') > -1 || this.$route.path.indexOf('/sports/navigation/') > -1) && store.getters['overlayState/getHamburgerMenuState'] === false && store.getters['overlayState/getBetslipState'] === false && store.getters['overlayState/getMyAccountDialogState'] === false) {
          return true
        }
      },
      isMyBetsActive () {
        if (this.$route.name === 'history-state' && store.getters['overlayState/getMyAccountDialogState'] === false && store.getters['overlayState/getSportsMenuState'] === false) {
          return true
        }
      },
      isInfoMenuEnabled () {
        let canhave = false
        let navitems = config.app.autoconf.MOBILE_BOTTOMNAV_MENUITEMS
        if (navitems && Array.isArray(navitems)) {
          canhave = navitems.includes('INFO')
        }
        return canhave
      },
      xtremepushWebInitialized () {
        return store.getters['getXtremepushWebInitialized']
      },
      xtremepushOnSiteEnabled () {
        return config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.CHANNEL && config.app.autoconf.XTREMEPUSH_ANALYTICS.CHANNEL.ON_SITE
      },
      xtremePushEnabledMobile () {
        return config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP // for mobile apps only
      },
      xtremepushInlineContent () {
        return store.getters['getXtremepushInlineContent']
      },
      isFitForPLayEnabled () {
        return config.app.autoconf.ENABLE_FIT_FOR_PLAY
      },
      isSearchEnabled () {
        return window.ctsautoconf.IS_SEARCH_ENABLED || false
      },
      noOfMsgs: () => store.getters['messageCenter/getNumberOfMessages'],
      myBetsPage () {
        return this.$route.name === 'history-state'
      },
      mobileTab: {
        get: function () {
          return store.getters['sbBetslipState/mobileTab']
        },
        set: function (tab) {
          store.commit('sbBetslipState/setMobileTab', tab)
        }
      },
      closeFromParent () {
        return store.getters['sbBetslipState/closeFromParent']
      },
      isReadOnly () {
        return config.app.autoconf.ROBO
      }
    },
    methods: {
      goToHome () {
        if (this.$route.name === 'promotions') {
          this.$router.push({name: 'sports'})
        }
      },
      toggleMyAccount () {
        this.userIsActive()
        if (this.myBetsPage) {
          this.$router.push({ path: '/' })
        }
        if (this.dialogMyAccount) {
          store.dispatch('overlayState/deactivateMyAccountDialog')
        } else {
          store.dispatch('overlayState/activateMyAccountDialog')
          this.sendGTMClickEvent('my account', 'open my account dialog', 'my-account btn', 'mobile bottom nav')
          this.deactivateBetslip()
          store.commit('sbBetslipState/setActiveBetSlip', false)
          store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
          this.goToHome()
          if (this.pmShowBetSlip) {
            store.dispatch('pmBetslipState/toggleBetslip')
          }
        }
      },
      toggleLogin () {
        let faceIdState = (window.ctsautoconf.MOBILE_LS && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) ? JSON.parse(localStorage.biometricsState) : false
        if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && !this.isFitForPLayEnabled)) {
          store.dispatch('overlayState/activateLoginDialog')
          mobileBridge.bridgeSendRequest('readData')
          this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'mobile bottom nav')
          return false
        } else if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && this.isFitForPLayEnabled)) {
          store.dispatch('overlayState/activateLoginDialog')
          this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'mobile bottom nav')
          return false
        }
        store.dispatch('overlayState/activateLoginDialog')
        if (this.pmShowBetSlip) {
          store.dispatch('pmBetslipState/toggleBetslip')
        }
        this.goToHome()
        store.dispatch('overlayState/activateLoginDialog')
        this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'mobile bottom nav')
      },
      toggleMenu () {
        this.userIsActive()
        if (this.myBetsPage) {
          this.$router.push({ path: '/' })
        }
        if (this.dialogSportsMenu) {
          store.dispatch('overlayState/deactivateSportsMenu')
        } else {
          this.deactivateBetslip()
          store.dispatch('overlayState/activateSportsMenu')
          this.sendGTMFooterNavigation('all sports', window.location.href)
          store.commit('sbBetslipState/setActiveBetSlip', false)
          store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
          this.goToHome()
          if (this.pmShowBetSlip) {
            store.dispatch('pmBetslipState/toggleBetslip')
          }
        }
      },

      toggleBetslip () {
        this.userIsActive()
        if (this.$route.name === 'savedbets') {
          this.$router.push({name: 'sports'})
        }
        //
        // this.clearFeedback(0, 'toggleBetslip')
        //
        if (this.dialogBetslip) {
          store.commit('sbBetslipState/setActiveBetSlip', false)
          store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
          this.deactivateBetslip()
          if (window.xtremepush || (config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP && window.ctsautoconf.MOBILE_LS)) {
            store.dispatch('sbBetslipState/sendGTMbetslipClosed')
          }
        } else {
          store.commit('sbBetslipState/setTab', this.mobileTab)
          store.dispatch('overlayState/activateBetslip')
          this.sendGTMClickEvent('betslip', 'open betslip dialog', 'betslip-btn', 'mobile bottom nav')
          store.dispatch('overlayState/deactivateSportsMenu')
          store.dispatch('overlayState/deactivateMyAccountDialog')
          store.dispatch('overlayState/deactivateHamburgerMenu')
          this.goToHome()
        }
      },
      toggleBetslip4History () {
        // this.clearFeedback(0, 'toggleBetslip4History')
        //
        if (this.$route.params && this.$route.params.hstate && this.brandTemplate !== 'generic_2') {
          let hs = this.$route.params.hstate.toLowerCase()
          if (!this.isLoggedIn) hs = ''
          switch (hs) {
            case 'active':
            case 'settled':
              if (!this.dialogBetslip) {
                store.dispatch('overlayState/activateBetslip')
              }
              break
          }
        }
      },
      toggleHome (userActive = true) {
        if (this.myBetsPage) {
          this.$router.push({ path: '/' })
        }
        if (userActive) {
          this.userIsActive()
        }
        this.isClickedFromBottomNavigation = true
        this.deactivateBetslip()
        store.commit('sbBetslipState/setActiveBetSlip', false)
        store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
        this.sendGTMClickEvent('sportsbook', 'go to homepage', 'home-btn', 'mobile bottom nav')
      },
      toggleHamburgerMenu () {
        if (this.myBetsPage) {
          this.$router.push({ path: '/' })
        }
        if (this.dialogHamburgerMenu) {
          store.dispatch('overlayState/deactivateHamburgerMenu')
        } else {
          this.deactivateBetslip()
          store.dispatch('overlayState/activateHamburgerMenu')
          store.dispatch('overlayState/deactivateSportsMenu')
          store.dispatch('overlayState/deactivateMyAccountDialog')
          this.goToHome()
        }
      },
      specialLink () {
        this.userIsActive()
        if (this.isOpenedFromWebView) {
          window.location = this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].action + '?uiView=true'
        } else {
          window.location = this.navigationSections.BOTTOM_NAV_MOBILE_APP_SPECIAL.fwnavigationgroups[0].fwnavigationitems[0].action
        }
      },
      go2Promotions () {
        if (this.$route.path.indexOf('/info/promotions') === -1) {
          this.$router.push({name: 'info', params: { infopagename: 'promotions' }})
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      go2PlacedBets () {
        if (this.$route.name !== 'placedbets') {
          this.$router.push({name: 'placedbets'})
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      go2SavedBets () {
        if (this.$route.name !== 'savedbets') {
          this.$router.push({name: 'savedbets'})
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      go2Contests () {
        if (this.$route.name !== 'contests') {
          this.$router.push({name: 'contests'})
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      showFeedBack (added) {
//        console.log('showFeedBack')
        if (this.mobileFeedback.enabled) {
          this.feedback = added ? this.$t('BetSlip.mobile.feedback.added') : ''
          // this.showParlayMsg()
          this.doShowParlayMsg = true
        } else {
          this.clearFeedback(0, 'showFeedBack')
        }
      },
      showParlayMsg (d) {
//        console.log('showParlayMsg')
        var self = this
        if (!self.mobileFeedback.enabled) {
          return
        }
        if (!this.doShowParlayMsg) {
          return
        }
        d = d || self.mobileFeedback.timeOut
        clearTimeout(self.feedbackTo)
        self.feedbackTo = setTimeout(function () {
          if (!self.gettingABTnR) {
            self.doShowParlayMsg = false
            let betType = {}
            let single = {}
            //
            if (self.selectionsNo === 1 && self.allowedReturnsSingles) {
              for (let i in self.allowedReturnsSingles) {
                single = self.allowedReturnsSingles[i]
                single.id = 'Single'
                single.potentialReturn = single.PotentialReturn
              }
            }
            //
            betType = (single && single.PotentialReturn && single) ||
              (self.allowedReturnsPRL && self.allowedReturnsPRL.isSgpA && self.allowedReturnsPRL.PotentialReturn && {id: 'SGPplus', potentialReturn: self.allowedReturnsPRL.PotentialReturn, participants: self.allowedReturnsPRL.participants}) ||
              (self.allowedReturnsSGP && {id: 'SGP', potentialReturn: self.allowedReturnsSGP}) ||
              (self.allowedReturnsPRL && self.allowedReturnsPRL.PotentialReturn && {id: 'Parlay', potentialReturn: self.allowedReturnsPRL.PotentialReturn, ParticipantsNo: self.allowedReturnsPRL.ParticipantsNo}) ||
              {id: 'ParlayNA', potentialReturn: -1}
            // var potentialReturn = self.allowedReturnsSGP || (self.allowedReturnsPRL && self.allowedReturnsPRL.PotentialReturn)
            let potentialReturn = betType && betType.potentialReturn
            if (potentialReturn) {
              let stake = self.mobileFeedback.stake
              let win = potentialReturn > 0 ? (stake * potentialReturn - stake) : 0
              win = priceFormat.roundToPrecision(win, 2)
              let phraseKey = 'BetSlip.mobile.feedback' + (betType.id ? '.' + betType.id : '')
              //
              self.feedback = self.$t(phraseKey, {
                stake: stake.toFixed(0),
                n: betType.ParticipantsNo || self.selectionsNo,
                win: win.toFixed(2),
                currency: self.currencySymbol
              })
              //
              if (betType.participants) {
                let participants = betType.participants
                let phraseKey = 'BetSlip.tab.Standard.heading.SGP_PARLAY.participants' +
                  (participants.sgpNo ? '.sgm' : '') + (participants.sgpNo > 1 ? 's' : '') +
                  (participants.fosNo ? '.fos' : '') + (participants.fosNo > 1 ? 's' : '')
                self.feedbackSGPplusParticipants = self.$t(phraseKey, {
                  sgp: participants.sgpNo,
                  fos: participants.fosNo
                })
              } else {
                self.feedbackSGPplusParticipants = ''
              }
              //
              if (self.mobileFeedback.autoHidePrlMsgAfter) {
                self.clearFeedback(self.mobileFeedback.autoHidePrlMsgAfter)
              }
            } else {
              self.clearFeedback(0, 'showParlayMsg')
            }
          } else {
            self.showParlayMsg(1)
          }
        }, d * 1000)
      },
      clearFeedback (d, caller) {
        d = d || 0
        // console.log('clearFeedback in ' + d, 'by:', caller)
        var self = this
        clearTimeout(self.feedbackTo)
        self.feedbackTo = setTimeout(function () {
          self.feedback = ''
          self.feedbackSGPplusParticipants = ''
        }, d * 1000)
      },
      go2PmBetting () {
        if (this.$route.name !== 'pm') {
          this.$router.push({ name: 'pmbetting' })
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      togglePmBetslip () {
        this.userIsActive()
        store.dispatch('pmBetslipState/toggleBetslip')
        store.dispatch('overlayState/deactivateMyAccountDialog')
      },
      togglePmBetslipOff () {
        this.userIsActive()
        store.dispatch('pmBetslipState/toggleBetslip', { showbetslip: false })
        store.dispatch('overlayState/deactivateMyAccountDialog')
      },
      pmNavToBreed (breed) {
        if (this.$route.name !== 'pm-for-period-breed' || (this.$route.params.breed && this.$route.params.breed !== breed)) {
          let navParams = { period: 'all', breed: breed }
          this.$router.push({ name: 'pm-for-period-breed', params: navParams })
        }
        this.deactivateBetslip()
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      /**
       * Check if nav groups are contained in ROUTERNAVGROUPS and are active
       * @param {Array<string>} navGroupKeys
       * @param {('contain'|'exact-match')} intersection how to calculate the intersaction match. 'contain' - are all group keys present in active ROUTERNAVGROUPS, 'exact-match' - are group keys exactly matching the active ROUTERNAVGROUPS
       */
      hasActiveNavGroups (navGroupKeys, intersection = 'contain') {
        let rngs = config.app.autoconf.ROUTERNAVGROUPS
        let navGroupKeysSafe = Array.isArray(navGroupKeys) ? navGroupKeys : []
        let intersected = rngs.groups.filter((group) => { return group.key && group.isactive && navGroupKeysSafe.includes(group.key) }) || []
        let has = false
        if (navGroupKeysSafe.length > 0 && intersected.length > 0) {
          switch (intersection) {
            case 'contain':
              has = intersected.length === navGroupKeysSafe.length
              break
            case 'exact-match':
              has = intersected.length === navGroupKeysSafe.length && intersected.length === rngs.length
              break
            default:
              has = false
              break
          }
        }
        return has
      },
      updateNavGroupKey () {
        let key = this.$router.currentRoute && this.$router.currentRoute.meta && this.$router.currentRoute.meta.navgroupkey ? this.$router.currentRoute.meta.navgroupkey : ''
        this.navgroupcontext4menu = key
      },
      /**
       * Check if navigation (button) element can be displayed in mobile bottom navigation
       * @param {string} navitemkey label/identifier of button (or other visual element) that is matched against MOBILE_BOTTOMNAV_MENUITEMS
       */
      canHaveNavElm (navitemkey) {
        let canhave = true
        let navitems = config.app.autoconf.MOBILE_BOTTOMNAV_MENUITEMS
        if (navitems && Array.isArray(navitems)) {
          canhave = navitems.includes(navitemkey)
        }
        return canhave
      },
      emitNavigationEvent (eventName, eventArgs = {}) {
        switch (eventName) {
          case 'notifyRacingIframeToDo':
            this.$root.$emit('notifyRacingIframeToDo', eventArgs)
            break
          default:
            // do nothing
            break
        }
      },
      goToSearchPage () {
        if (['search'].indexOf(this.$route.name) === -1) {
          this.$router.push({name: 'search'})
        }
        this.deactivateBetslip()
        store.commit('sbBetslipState/setActiveBetSlip', false)
        store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
        store.dispatch('overlayState/deactivateHamburgerMenu')
      },
      toggleMyBets () {
        if (this.myBetsPage) {
          this.$router.push({ path: '/' })
        } else {
          store.dispatch('overlayState/closeAll')
          // this.$router.push({ path: '/account/bethistory/active' })
          this.$router.push({ name: 'history-state', params: { state: 'active' } })
        }
      },
      deactivateBetslip () {
        if (this.dialogBetslip) {
          this.mobileTab = store.getters['sbBetslipState/tab']
        }
        setTimeout(() => { store.commit('sbBetslipState/setTab', 'REGULAR') }, 0)
        //
        store.dispatch('overlayState/deactivateBetslip')
      }
    },

    watch: {
      selectionsNo (newVal, oldVal) {
        // console.log('watch selectionsNo:', oldVal, '=>', newVal)
        clearTimeout(this.feedbackTo)
        this.feedback = ''
        this.feedbackSGPplusParticipants = ''
        //
        if (!this.dialogBetslip && newVal === 1 && oldVal === 0 && !this.isFastBetEnabled && this.popBetSlipOn1stSelection) {
          setTimeout(function () {
            store.dispatch('overlayState/activateBetslip')
          }, 0)
        } else if (newVal) {
          this.showFeedBack(newVal > oldVal)
        }
      },
      isLoggedIn (newVal, oldVal) {
        if (newVal === true) {
          this.toggleBetslip4History()
        }
        if (newVal === false) {
          this.toggleHome(false)
        }
      },
      $route: function () {
        this.updateNavGroupKey()
      },
      gettingABTnR (newVal, oldVal) {
        // console.log('Watch gettingABTnR', oldVal, '=>', newVal)
        if (!newVal) {
          this.showParlayMsg()
        }
      },
      closeFromParent (newVal, oldVal) {
        // console.log('Watch closeFromParent', oldVal, '=>', newVal)
        if (newVal) {
          this.deactivateBetslip()
        }
      }
    },

    created () {
      setInterval(() => {
        let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
        if (value >= 0) {
          let minutes = Math.floor(value / 60)
          let seconds = value - minutes * 60
          seconds = (seconds < 10 ? ('0' + seconds) : seconds)
          minutes = (minutes < 10 ? ('0' + minutes) : minutes)
          this.sessionTime = `${minutes}:${seconds}`
        }
      }, 1000)

      this.toggleBetslip4History()
      this.updateNavGroupKey()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"
  @import "fonts";

  .bottom-navigation
    &.hidden
      .v-navigation-drawer
        max-height: 100% !important
      .v-bottom-nav
        display: none

  .header
    padding-top 0
    .title
      padding-top 21px
  .session-info
    font-size 10px
  .bottom-navigation
    .v-bottom-nav
      z-index: 20000 !important
      background: #fff
      border-top: solid 1px #CFD6DB

      .v-btn
        filter: none
        padding: 0
        min-width: 50px
        opacity: 1
        position: relative
        display: block

        >>> .v-btn__content
          padding: 0
          flex-direction column !important
          font-weight normal

          &:before
            display: none

          i.icon
            margin: 0

        .badge
          background-color: #ff671f
          color: #fff
          position: absolute
          font-size: 12px
          font-weight: normal
          top: -2px
          margin-left: 12px

        .betslip_mobile_msg
          position: absolute
          bottom: 65px
          width: 320px
          height: 28px
          p
            display: inline-block
            background: #2396FC
            color: #ffffff
            padding: 5px 10px
            max-width: 320px
            overflow hidden
            white-space: normal
            border-radius: 5px
            height: 28px
            &:after
              material-icons()
              display: block
              content: 'arrow_drop_down'
              margin: auto
              line-height: 0px
              font-size: 30px
              color: #2396FC
              position: absolute
              bottom: 0
              left: 50%
              margin-left: -15px
              z-index: 1000
        .btn-icon-container
          /*background-color: darkgoldenrod*/
          display: flex;
          align-items: center;
          justify-content: center;
          height: 28px
          margin-bottom: 4px
          i.v-icon
            margin-bottom: 0

      >>> .igt-icon:not(.background)
          height: 33px
          display: flex
          align-items: center

      >>> .igt-icon
        &.background
          width: 33px
          height: 33px

        > span
          width: 17px
          height: 17px

    .betslip-button
      >>> .igt-icon
        &.background
          background-color: #F0F3F8

      &.active
        >>> .igt-icon
          &.background
            background-color: #2396FC

      &.hasSelections
        >>> .igt-icon
          &.background
            background-color: #1493ff

.bottom_nav_text
  font-size: 10px;
  line-height: 90%;
  white-space: normal;
  max-width: 96%;
  overflow: visible;
  max-height: 11px;
  color: #99a8b1
  padding-top: 1px
  &.blue
    color #1493ff !important
    background none !important

  /* iphone XS */
.os-ios
  @media only screen and (min-device-width: 375px) and (min-device-height: 812px) and (-webkit-min-device-pixel-ratio: 3)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      padding-top 5px
  /* iphone XS Max */
.os-ios
  @media only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-min-device-pixel-ratio: 3)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      padding-top 5px
  /* iphone XR */
.os-ios
  @media only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-min-device-pixel-ratio: 2)
    .bottom-nav
      height 94px !important
      padding-bottom 34px
      padding-top 5px
.close
  flex-grow: 0
  @media mobile-big-and-below
    display: block

  .v-btn
    min-width: 0
    position: absolute
    top: -17px
    right: -8px
    width: 24px
    height: 24px
    .icon
      font-weight: normal
      font-size: 26px !important
    >>>.v-btn__content
      padding: 0
.v-icon
  color #073f79 !important
.dialog-menu.v-navigation-drawer
  z-index 20

</style>



// WEBPACK FOOTER //
// src/components/layout/parts/BottomNavigation.vue